import { useNavigate, useParams } from 'react-router-dom';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { TaskViewBreadcrumbItems } from 'data/commonData';
import TaskDetailsContent from './TaskDetailsContent';

/**
 * Standalone task page (deep-linkable: /home/apps/tasks/view/:id). Kept so
 * notification/email/stage-reminder links keep resolving. The body is shared
 * with the global TaskDetailsOffcanvas via TaskDetailsContent.
 */
const TaskDetails = () => {
  const { taskId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="py-4">
      <PageBreadcrumb items={TaskViewBreadcrumbItems} />
      <TaskDetailsContent
        taskId={taskId as string}
        onClose={() => navigate('/home/apps/tasks')}
      />
    </div>
  );
};

export default TaskDetails;
